import camelcaseKeys from 'camelcase-keys'
import throttle from 'lodash.throttle'

import type {
  DirectoryAccount,
  DirectoryAccountDTO,
} from '@/modules/projects/stores/types'
import { executeGet } from '@/services/lukita'
import { captureException } from '@/services/monitoring'
import type {
  DirectoryAccountsActions,
  DirectoryAccountsLoaders,
  ProjectStoreCreator,
} from './types'

const normalize = (entry: DirectoryAccount | DirectoryAccountDTO) =>
  camelcaseKeys(entry) as DirectoryAccount

export const directoryAccountsActions: ProjectStoreCreator<
  DirectoryAccountsActions
> = (set) => ({
  startLoadingDirectoryAccounts: () => set({ loadingDirectoryAccounts: true }),
  stopLoadingDirectoryAccounts: () => set({ loadingDirectoryAccounts: false }),

  setDirectoryAccounts: (entries) =>
    set({ directoryAccounts: entries.map(normalize) }),
})

export const directoryAccountsLoaders: ProjectStoreCreator<
  DirectoryAccountsLoaders
> = (_set, get) => ({
  // The directory only relabels rows the page can already draw, and this SPA can ship before the
  // endpoint does, so a failure leaves an empty directory instead of breaking the page.
  fetchDirectoryAccounts: throttle(async (slug: string) => {
    get().actions.startLoadingDirectoryAccounts()
    try {
      const response = await executeGet(`/projects/${slug}/directory_accounts`)
      get().actions.setDirectoryAccounts(await response.json())
    } catch (error) {
      captureException(error as Error)
      get().actions.setDirectoryAccounts([])
    } finally {
      get().actions.stopLoadingDirectoryAccounts()
    }
  }, 500),
})
